import React, { Component } from "react";
import { DKLabel } from "deskera-ui-library";

/*
PROPS
- data // this is current componets data
- onDataChange
- onClose
*/

export default class CustomHtmlEditor extends Component {
  constructor(props) {
    super(props);
    this.componentData = this.props.data;
  }

  //////////////////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////////////////

  render() {
    return (
      <div className="parent-width mt-l">
        {/* ////////////////////////////////////////////////////////////////////////////////////////// */}

        <div className="parent-width column border-box border-m p-r shadow-s border-radius-s">
          <DKLabel text="HTML" className="fw-m" />
          <textarea
            type="text"
            className="border-none bg-gray1 border-m parent-width parent-height border-radius-s border-box p-v-s p-h-s mt-s"
            style={{
              minHeight: 180,
              fontSize: 13,
              resize: "none",
            }}
            value={this.componentData.value}
            onChange={(e) => {
              this.changeValue(e.target.value);
            }}
          />
        </div>
        {/* ////////////////////////////////////////////////////////////////////////////////////////// */}
      </div>
    );
  }
  changeValue = (value) => {
    this.componentData.value = value;
    this.props.onDataChange(this.componentData);
  };
}
